import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSafeTranslation } from '../hooks/useSafeTranslation';

export interface HealthPotionReminderModalProps {
  show: boolean;
  onHide: () => void;
  onGoToInventory: () => void;
  onContinueWithoutUsing: () => void;
}

/** Reminder when the player has health potions and at most 5 lives (not full). */
const HealthPotionReminderModal: React.FC<HealthPotionReminderModalProps> = ({
  show,
  onHide,
  onGoToInventory,
  onContinueWithoutUsing,
}) => {
  const { t } = useSafeTranslation();

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{t('quiz.healthPotionReminderTitle', 'Health potion in inventory')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          {t(
            'quiz.healthPotionReminderBody',
            'You have few lives left (at most 5) and health potions in your inventory. Open your inventory to restore lives before playing.'
          )}
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-between flex-wrap gap-2">
        <Button variant="outline-secondary" onClick={onContinueWithoutUsing}>
          {t('quiz.healthPotionReminderContinue', 'Continue anyway')}
        </Button>
        <Button variant="primary" onClick={onGoToInventory}>
          <i className="bi bi-bag me-2" aria-hidden />
          {t('quiz.healthPotionReminderGoInventory', 'Go to inventory')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HealthPotionReminderModal;
